import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import CommonEN from "./CommonEN.json";
import CommonDE from "./CommonDE.json";

i18n.use(LanguageDetector).init({
  // we init with resources
  detection: {
    // order and from where user language should be detected
    order: ["cookie", "navigator", "localStorage", "querystring", "htmlTag", "path", "subdomain"],
    lookupCookie: "locale",
  },
  resources: {
    en: {
      common: CommonEN,
    },
    de: {
      common: CommonDE,
    },
  },
  fallbackLng: "en",
  debug: false,

  // have a common namespace used around the full app
  ns: ["common"],
  defaultNS: "common",

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ",",
  },

  react: {
    wait: true,
  },
});

export default i18n;
